import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/agent/sanjiao_bai.png'


const _hoisted_1 = { class: "calender_popup" }

import { ref } from 'vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'timeSelector',
  emits: ['getSelectedDateData'],
  setup(__props, { emit: __emit }) {

const show = ref(false)

const today = new Date();
const minDate = new Date();
minDate.setDate(today.getDate() - 30);

const maxDate = new Date();
const defaultDate = new Date();
const date = ref('');
const emits = __emit
const showTimePopup = () => {
    show.value = true
}
const formatDate = (date: Date) =>
    `${date.getFullYear()}-${(date.getMonth() + 1)
        .toString()
        .padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;

const onConfirm = (value: Date) => {
    show.value = false;
    date.value = formatDate(value);
    emits('getSelectedDateData', date.value)
};

return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_calendar = _resolveComponent("van-calendar")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_van_row, {
      class: "timePop_container",
      onClick: showTimePopup
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_col, { span: "22" }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(date.value ? `${date.value} 00:00AM - ${date.value} 12.59PM`
                : `${formatDate(_unref(defaultDate))} 00:00 - ${formatDate(_unref(defaultDate))} 23:59`), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_van_col, { span: "2" }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [
            _createElementVNode("div", { class: "dropDown" }, [
              _createElementVNode("img", {
                src: _imports_0,
                alt: ""
              })
            ], -1)
          ])),
          _: 1
        })
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_van_calendar, {
        show: show.value,
        "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
        title: 'Seleção de data',
        "show-subtitle": false,
        "max-date": _unref(maxDate),
        "min-date": _unref(minDate),
        "show-mark": false,
        "show-confirm": false,
        "default-date": _unref(defaultDate),
        onConfirm: onConfirm
      }, {
        "bottom-info": _withCtx(() => _cache[2] || (_cache[2] = [
          _createElementVNode("div", { class: "custom-day" }, [
            _createElementVNode("div", { class: "time-label" }, "00:00")
          ], -1)
        ])),
        _: 1
      }, 8, ["show", "max-date", "min-date", "default-date"])
    ])
  ], 64))
}
}

})